import { createContext, useContext, useEffect, useState } from "react";
import api, { fmtErr } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, object=auth
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/auth/me"); setUser(data); }
      catch (err) { console.warn("/auth/me failed (likely anonymous):", err.response?.status || err.message); setUser(false); }
    })();
  }, []);

  // Heartbeat — ping every 30s while authenticated; marks user as 'online' server-side
  useEffect(() => {
    if (!user || user === false) return;
    const ping = () => api.post("/auth/ping").catch(() => {});
    ping();
    const id = setInterval(ping, 30_000);
    return () => clearInterval(id);
  }, [user]);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.access_token) localStorage.setItem("access_token", data.access_token);
      setUser(data); return true;
    } catch (e) { setError(fmtErr(e.response?.data?.detail) || e.message); return false; }
  };
  const register = async (email, password, name, country = null) => {
    setError("");
    try {
      const { data } = await api.post("/auth/register", { email, password, name, country });
      if (data.access_token) localStorage.setItem("access_token", data.access_token);
      setUser(data); return true;
    } catch (e) { setError(fmtErr(e.response?.data?.detail) || e.message); return false; }
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (err) { console.warn("logout call failed:", err.message); }
    localStorage.removeItem("access_token");
    setUser(false);
  };
  const refreshMe = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); }
    catch (err) { console.warn("refreshMe failed:", err.message); }
  };

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout, refreshMe, error }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
